/* eslint-disable no-bitwise */
export const getInitials = (string, numberOfCharacters = 2) =>
  string
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, numberOfCharacters);

export const getFirstCharacter = (string) => string.slice(0, 1);

export const getLast4digits = (text) => {
  if (typeof text === 'number') {
    return `••${text.toString().slice(-4)}`;
  }

  if (typeof text === 'string') {
    return `••${text.slice(-4)}`;
  }

  return '';
};

/**
 * Function convert account number
 *
 * @param {string} string - Account number: '12345678'
 * @returns {string} - '(••5678)'
 */
export const formatStringWithDot = (string) => `(••${string?.replace(/.(?=.{4,}$)/g, '')})`;

/**
 * Function convert account number to dot and last 4 digits
 *
 * @param {string} string - Account number: '12345678'
 * @returns {string} - '••••5678'
 */
export const formatStringWithOnlyDot = (string = '') => `••${string?.replace(/.(?=.{4,}$)/g, '')}`;

export const capitalizeFirstLetter = (string = '') =>
  string.charAt(0).toUpperCase() + string.slice(1);

/**
 * Function format payment status text
 *
 * @param {string} string - Text: 'pending_review'
 * @param {string} sliptCharacter - The character user want to take for slipt
 * @returns {string} - Update case first letter of the sentence and add a space between words
 */
export const addSpaceAndCapitalizeFirstLetter = (string, sliptCharacter = '_') => {
  const words = string.split(sliptCharacter);
  const result = words.map((word) => capitalizeFirstLetter(word || '')).join(' ');
  return result;
};

/**
 * Function hash code from a string
 *
 * @param {string} str The string to hash.
 * @returns {number} - A 32bit integer
 */
export const hashCode = (str) => {
  let hash = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);

    hash = (hash << 5) - hash + chr;

    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

/**
 * Function convert account number to any character and last 4 digits
 * @param {object} param0
 * @param {string} param0.formatCharacter - The character is add to result string
 * @param {number} param0.numberFormatCharacter - The number of character want to add to result string
 * @param {string} param0.accountNumber - The account number input
 * @returns {string} - The formatted string
 */
export const formatAccountNumber = ({
  formatCharacter,
  accountNumber,
  numberFormatCharacter = 1
}) => {
  const preFormatString = Array.from({ length: numberFormatCharacter }, () => formatCharacter).join(
    ''
  );

  return `${preFormatString}${accountNumber?.replace(/.(?=.{4,}$)/g, '')}`;
};
